import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import logo from '../../../assets/images/logos/powertrack.png';

import AppContext from '../../../store/App/contexts';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const emailHandler = (e) => {
    let email = e.target.value;
    let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (reg.test(email) === false || email === null) {
      setEmail(' ');
    } else {
      setEmail(e.target.value);
    }
  };

  const passwordHandler = (e) => {
    let password = e.target.value;

    if (password === ' ') {
    } else {
      setPassword(e.target.value);
    }
  };

  return (
    <AppContext.Consumer>
      {({ loginHandler }) => (
        <div
          className="d-flex flex-column text-center align-items-center justify-content-center"
          style={{ height: '100vh' }}
        >
          <div
            className="container"
            style={{
              position: 'absolute',
              height: '55%',
              width: '350px',
              top: '100px',
            }}
          >
            <div className="mb-4 pb-2 mx-auto" style={{ width: '200px' }}>
              <img src={logo} style={{ width: '200px' }} alt="" />
            </div>
            <h5>Admin</h5>
            <form onSubmit={(e) => loginHandler('admin', email, password, e)}>
              <input
                className="form-control mt-4 mb-2"
                type="email"
                placeholder="Email"
                onChange={(e) => emailHandler(e)}
              />
              <div style={{ position: 'relative' }}>
                <input
                  className="form-control mb-4"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Password"
                  onChange={(e) => passwordHandler(e)}
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    color: '#555',
                  }}
                >
                  {showPassword ? (
                    <i
                      className="far fa-eye-slash"
                      style={{ color: '#888383', fontSize: '14' }}
                    ></i>
                  ) : (
                    <i
                      className="far fa-eye"
                      style={{ color: '#888383', fontSize: '14' }}
                    ></i>
                  )}
                </span>
              </div>
              <button
                type="submit"
                className="btn btn-block btn-brand"
                style={{ width: '100%' }}
              >
                Log in
              </button>
            </form>
            <div
              className="text-secondary"
              style={{
                padding: '20px',
                textAlign: 'right',
              }}
            >
              <Link
                className="text-brand"
                to="/forgot-password/admin"
                style={{ textDecoration: 'none' }}
              >
                Forgot password?
              </Link>
            </div>
          </div>
        </div>
      )}
    </AppContext.Consumer>
  );
};

export default AdminLogin;
